export default {
    documentDownloadLink: {
        dataTrackId: 'document-download-link',
        dataTrackLinkname: 'last ned dokument',
    },
    documentListItem: {
        dataTrackId: 'document-list-item',
        dataTrackLinkname: 'dokument listeelement',
    },
    selectDocumentFilter: {
        dataTrackId: 'select-document-filter',
        dataTrackLinkname: 'velg type dokument',
    },
};
